export const BID_LOAD_COMPLETE = 'BID_LOAD_COMPLETE';
export const OFFER_LOAD_COMPLETE = 'OFFER_LOAD_COMPLETE';
export const DELETE_BID_COMPLETE = 'DELETE_BID_COMPLETE';
export const DELETE_OFFER_COMPLETE = 'DELETE_OFFER_COMPLETE';
